//Principais
import { Component, inject, OnInit, signal, TemplateRef, ViewChild, ViewChildren, QueryList, ElementRef } from "@angular/core";
import { formatDate, registerLocaleData } from '@angular/common';
import myLocalePt from '@angular/common/locales/pt';
import { FormControl, FormGroup } from "@angular/forms";
import { NgSelectConfig } from "@ng-select/ng-select";
import { HistoricoChamado } from "src/app/shared/models/chamados/historico";
import { ListarChamados } from "src/app/shared/models/chamados/listar-chamados";
import { NaoOcorrencia } from "src/app/shared/models/nao-ocorrencia/NaoOcorrencia";
import { Consolidado } from "src/app/shared/models/relatorio/Consolidado";
import { ListarCalendario } from "src/app/shared/models/relatorio/listar-calendario";
import { BaseChartDirective, NgChartsModule } from 'ng2-charts';
import { ChartConfiguration, ChartData, ChartEvent, ChartType } from 'chart.js';
import { Chart, registerables } from 'chart.js';

//Services
import { BaseComponent } from "components/base/base.component";
import { lastValueFrom } from "rxjs";
import { AlunosRecorrentes } from "src/app/shared/models/aluno/AlunosRecorrentes";
import { ListarEncaminhados } from "src/app/shared/models/chamados/listar-encaminhados";
import { Diretoria } from "src/app/shared/models/diretoria/Diretoria";
import { Escola } from "src/app/shared/models/escola/Escola";
import { FiltroPadrao } from "src/app/shared/models/filtro-padrao/filtroPadrao";
import { ChamadoService } from "src/app/shared/services/chamado.service";
import { EncaminhamentoService } from "src/app/shared/services/encaminhamento.service";
import { NaoOcorrenciaService } from "src/app/shared/services/nao-ocorrencia.service";
import { RelatorioService } from "src/app/shared/services/relatorio.service";
import { FiltroPadraoPec } from "src/app/pages/pec/models/filtro-padrao-pec";
import { GraficoService } from "src/app/pages/pec/services/grafico.service";
import { angularCommonImports } from 'src/app/shared/ui/angular-common';
import { convivaCommonImports } from 'src/app/shared/ui/conviva-common';
import { libsCommonImports } from 'src/app/shared/ui/libs-common';
import { FiltroPadraoComponent } from 'components/filtro-padrao/filtro-padrao.component';


//Models
import { EncaminhamentosAberto, ValidadosNaoValidados } from "../../models/rel-pec-psicologo";
import { AgendamentoRealizado } from "../../models/rel-pec-psicologo";
import { AcolhimentoConcluido } from "../../models/rel-pec-psicologo";
import { AcolhimentoAtraso } from "../../models/rel-pec-psicologo";
import { Prevencao } from "../../models/rel-pec-psicologo";

declare const window: any;
declare let html2canvas: any;

@Component({
  selector: 'app-relatorio-pec-psicologo',
  standalone: true,
  templateUrl: './relatorio-pec-psicologo.component.html',
  styleUrl: './relatorio-pec-psicologo.component.scss',
  imports: [angularCommonImports, convivaCommonImports, libsCommonImports, NgChartsModule]
})

export class RelatorioPecPsicologoComponent extends BaseComponent implements OnInit {
  @ViewChildren(BaseChartDirective) charts!: QueryList<BaseChartDirective>;
  @ViewChild('pdfContent', { static: false }) pdfContent!: ElementRef;
  @ViewChild(FiltroPadraoComponent) filtroPadraoComponent: FiltroPadraoComponent;


  //Injeção
  config = inject(NgSelectConfig);
  chamadoService = inject(ChamadoService);
  encaminhamento = inject(EncaminhamentoService);
  relatorioService = inject(RelatorioService);
  naoOcorrenciaService = inject(NaoOcorrenciaService);
  graficoService = inject(GraficoService);
  public page = 1;
  public totalRegisterCount = 0;

  public get Psicologo() { return (this.atribuicoesLogin == undefined && this.userLogado?.flPsicologo); }
  public get CoordenadorPsicologo() { return this.userLogado?.DadosUsuario?.filter(s => s.CodigoPerfil == 1632).length }
  public currentDate: string;
  public mesCalendario: number;
  public anoCalendario: number;
  public daysInMonth: { date: Date, isWeekend: boolean, isHoliday: boolean }[] = [];
  public qtdeCaracteresDescricao: number = 0;
  public showModalAdicionarChamado = false;
  public lstDiretorias: Diretoria[] = [];
  public lstEscolas: Escola[] = [];

  public encaminhamentosAberto: EncaminhamentosAberto;
  public agendamentoRealizado: AgendamentoRealizado;
  public acolhimentoConcluido: AcolhimentoConcluido;
  public acolhimentoAtraso: AcolhimentoAtraso;
  public prevencao: Prevencao;
  public validadosNaoValidados: ValidadosNaoValidados = { semAtividades: 0, naoValidados: 0, validados: 0, totalValidadosNaoValidados: 0, validadosFormatado: "", naoValidadosFormatado: "", semAtividadesFormatado: "", totalValidadosNaoValidadosFormatado: "" };
  public infoPeriodo: any = {
    polo: '-',
    diretoria: '-',
    escola: '-',
    psicologo: '-',
    ciclo: '-',
    dataInicio: '-',
    dataFim: '-'
  };
  constructor() {
    Chart.register(...registerables);
    Chart.defaults.devicePixelRatio = 1;
    super();
  }

  @ViewChild('modalContent') modalContent!: TemplateRef<any>;
  public showModal = false;
  public submittedModal = false;
  public tituloModal = '';
  public descricaoExclusao = '';
  public descricaoNaoOcorrencia = '';
  public dataOcorrenciaNaoOcorrencia = new Date();
  public chamadoARemover = 0;
  public logoBase64: string | undefined;
  public formRelatorio: FormGroup;
  public get form() { return this.formRelatorio.controls; }




  // FILTROS
  public gravidades = [{ id: 1, name: 'Amarelo' }, { id: 2, name: 'Vermelho' }];
  public lstChamados: ListarChamados[] = [];
  public lstAllChamados: ListarChamados[] = [];
  public alunosRecorrentes: AlunosRecorrentes[] = [];
  public listaDias: ListarCalendario[] = [];
  public chamadoFiltrado: number = 0;
  public formHomeNaoOcorrencia!: FormGroup;
  public lstDadosGrafico: ListarChamados[] = [];

  public get formNaoOco() { return this.formHomeNaoOcorrencia.controls; }

  // MODAL
  public submitted = false;
  public showPesquisa = false;
  public showModalCalendarioOcorrencia = false;
  public showModalCadastraNaoOcorrencia = false;
  public codigoChamadoSelected: number;
  public codigoEnvolvidoSelected: number;
  public formModal!: FormGroup;
  public qtyEncaminhamentos: string;
  public qtyEncaminhamentosAberto: string;
  public qtyEncaminhamentosrealizado: string;
  public qtyEncaminhamentosConcluidos: string;
  public qtyEncaminhamentosAtraso: string;
  public qtyEncaminhamentosPrevencao: string;
  public porcEncaminhamentosAberto: number = 0;
  public porcEncaminhamentosRealizado: number = 0;
  public porcEncaminhamentosConcluido: number = 0;
  public porcEncaminhamentosAtraso: number = 0;
  public porcEncaminhamentosPrevencao: number = 0;
  public temDadosGraficos = false;


  //public porcAcoesPrevencao: number = 0;


  public barChartType: ChartType = 'bar';

  public barChartOptionsAberto: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => {
            return [`Encaminhamentos em aberto:`,
              ` ${context.parsed.y}%`,
              ` (${this.encaminhamentosAberto?.quantidade} registros`,
              ` ${this.encaminhamentosAberto?.total} total))`];
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 100, 
        title: { display: true, text: 'Porcentagem (%)' }
      }
    }
  };
  public barChartOptionsRealizado: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => {
            return [`Agendamento realizado: ${context.parsed.y}%`,
            ` (${this.agendamentoRealizado?.quantidade} registros`,
            ` ${this.agendamentoRealizado?.total} total))`];
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 100, 
        title: { display: true, text: 'Porcentagem (%)' }
      }
    }
  };
  public barChartOptionsAcolhimentoConcluido: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => {
            return [`Acolhimento concluído: ${context.parsed.y}%`,
            `(${this.acolhimentoConcluido?.quantidade} registros`,
            `${this.acolhimentoConcluido?.total} total))`];
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 100, 
        title: { display: true, text: 'Porcentagem (%)' }
      }
    }
  };
  public barChartOptionsAcolhimentoAtrasado: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        yAlign: 'bottom',
        callbacks: {
          label: (context) => {
            return [`Acolhimento em atraso:`,
              `${context.parsed.y}% (${this.acolhimentoAtraso?.quantidade} registros`,
              `${this.acolhimentoAtraso?.total} total))`];
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 100, 
        title: { display: true, text: 'Porcentagem (%)' }
      }
    }
  };
  public barChartOptionsprevencao: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => {
            return [`Prevenção:`,
              `${context.parsed.y}% (${this.prevencao?.quantidade} registros`,
              `${this.prevencao?.total} total))`];
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 100, 
        title: { display: true, text: 'Porcentagem (%)' }
      }
    }
  };

  public barChartDataAberto: ChartData<'bar'> = {
    labels: [''],
    datasets: [
      {
        label: 'Encaminhamentos em aberto',
        data: [0],
        backgroundColor: ['rgba(118, 192, 245, 1)'],
        borderColor: ['rgba(118, 192, 245, 1)'],
        borderWidth: 1,
        barThickness: 20,
        maxBarThickness: 26,
      }
    ]
  };
  public barChartDataRealizado: ChartData<'bar'> = {
    labels: [''],
    datasets: [
      {
        label: 'Agendamento realizado',
        data: [0],
        backgroundColor: ['rgba(98, 179, 104, 1)'],
        borderColor: ['rgba(98, 179, 104, 1)'],
        borderWidth: 1,
        barThickness: 20,
        maxBarThickness: 26,
      }
    ]
  };
  public barChartDataAcolhimento: ChartData<'bar'> = {
    labels: [''],
    datasets: [
      {
        label: 'Acolhimento concluído',
        data: [0],
        backgroundColor: ['rgba(122, 123, 142, 1)'],
        borderColor: ['rgba(122, 123, 142, 1)'],
        borderWidth: 1,
        barThickness: 20,
        maxBarThickness: 26,
      }
    ]
  };
  public barChartDataAtraso: ChartData<'bar'> = {
    labels: [''],
    datasets: [
      {
        label: 'Acolhimento em atraso',
        data: [0],
        backgroundColor: ['rgba(255, 165, 0, 1)'],
        borderColor: ['rgba(255, 165, 0, 1)'],
        borderWidth: 1,
        barThickness: 20,
        maxBarThickness: 26,
      }
    ]
  };
  public barChartDataPrevencao: ChartData<'bar'> = {
    labels: [''],
    datasets: [
      {
        label: 'Prevenção',
        data: [0],
        backgroundColor: ['rgba(157, 128, 203, 1)'],
        borderColor: ['rgba(157, 128, 203, 1)'],
        borderWidth: 1,
        barThickness: 20,
        maxBarThickness: 26,
      }
    ]
  };

  public async ngOnInit() {
    this.formRelatorio = new FormGroup({
      dataInicio: new FormControl(null),
      dataFim: new FormControl(null)
    });
  }

  setFilters(event: FiltroPadrao) {
    this.filtros = event;
  }

  async listeningFiltroEmitter(eventFilter: FiltroPadrao) {
    this.spinnerService.show();

    this.setFilters(eventFilter);

    const dataInicio = eventFilter.fpDataInicio ?? null;
    const dataFim = eventFilter.fpDataFim ?? null;

    this.formRelatorio.patchValue({
      dataInicio: dataInicio,
      dataFim: dataFim
    });

    this.infoPeriodo = {
      polo: this.getNomePolo(eventFilter.codigoPolo),
      diretoria: this.getNomeDiretoria(eventFilter.codigoDiretoria),
      escola: this.getNomeEscola(eventFilter.codigoEscola),
      ciclo: this.getNomeCiclo(eventFilter.codigoTipoEnsino),
      psicologo: this.getNomePsicologo(eventFilter.cpf),
      dataInicio: dataInicio,
      dataFim: dataFim
    };

    const aberto = await this.GetGraphEncaminhamentosAberto();
    const agendado = await this.GetGraphAgendamentoRealizado();
    const concluido = await this.GetGraphAcolhimentoConcluido();
    const atraso = await this.GetGraphAcolhimentoAtraso();
    const prevencao = await this.GetGraphPrevencao();
    await this.GetGraphValidadosNaoValidados();

    const algumTemDados = aberto || agendado || concluido || atraso || prevencao;

    if (!algumTemDados) {
      this.toastr.warning("Não existem registros para essa pesquisa");
    }
    //this.temDadosGraficos = valores.some(v => Number(v) > 0);


    this.spinnerService.hide();
  }

  public SetParametrosGrafico(): FiltroPadraoPec {
    const pamatroGrafico = new FiltroPadraoPec();
    pamatroGrafico.codigoPolo = this.filtros.codigoPolo;
    pamatroGrafico.codigoDiretoria = this.filtros.codigoDiretoria;
    pamatroGrafico.codigoEscola = this.filtros.codigoEscola ?? 0;
    pamatroGrafico.codigoTipoEnsino = this.filtros.codigoTipoEnsino;
    pamatroGrafico.nomeTipoEnsino = this.filtros.nomeTipoEnsino;
    pamatroGrafico.anoAtual = this.filtros.anoAtual;
    pamatroGrafico.atividadeDiretoria = this.userLogado?.apenasDiretoria ?? this.filtros.atividadeDiretoria!;
    pamatroGrafico.fpDataInicio = (this.form?.dataInicio?.value === '' ? null : this.form?.dataInicio?.value ?? this.filtros?.fpDataInicio ?? null);
    pamatroGrafico.fpDataFim = (this.form?.dataFim?.value === '' ? null : this.form?.dataFim?.value ?? this.filtros?.fpDataFim ?? null);
    pamatroGrafico.cpf = this.filtros.cpf;
    return pamatroGrafico;
  }
  private updateChartById(id: string): void {
    const chart = this.charts.find(c => c.chart?.canvas?.id === id);
    chart?.update();
  }

  public async GetGraphEncaminhamentosAberto() {
    this.spinnerService.show();
    const parametros = this.SetParametrosGrafico();

    const result = await lastValueFrom(this.graficoService.GetDataGraphEncaminhamentosAberto(parametros))
      .catch((err) => this.convivaErrors.handleResultError(err));

    if (!result?.isSucess) {
      this.toastr.error(result?.message || 'Erro ao carregar gráfico Encaminhamentos em aberto');
      this.spinnerService.hide();
      return;
    }


    this.encaminhamentosAberto = result.data;


    this.qtyEncaminhamentosAberto = new Intl.NumberFormat('pt-BR').format(this.encaminhamentosAberto.quantidade);
    this.porcEncaminhamentosAberto = this.encaminhamentosAberto.percentual;

    //// Atualiza somente a posição 0
    this.barChartDataAberto.datasets[0].data[0] = this.encaminhamentosAberto.percentual;

    this.updateChartById('chartAberto');
    this.spinnerService.hide();


    if (!this.encaminhamentosAberto || this.encaminhamentosAberto.quantidade === 0) {
      return false;
    }
    return true;
  }

  public async GetGraphAgendamentoRealizado() {
    this.spinnerService.show();
    const parametros = this.SetParametrosGrafico();


    const result = await lastValueFrom(this.graficoService.GetDataGraphAgendamentoRealizado(parametros))
      .catch((err) => this.convivaErrors.handleResultError(err));

    if (!result?.isSucess) {
      this.toastr.error(result?.message || 'Erro ao carregar gráfico Agendamento realizado');
      this.spinnerService.hide();
      return;
    }

    this.agendamentoRealizado = result.data;



    // Atualiza somente a posição 1
    this.barChartDataRealizado.datasets[0].data[0] = this.agendamentoRealizado.percentual;

    this.qtyEncaminhamentosrealizado = new Intl.NumberFormat('pt-BR').format(this.agendamentoRealizado.quantidade);
    this.porcEncaminhamentosRealizado = this.agendamentoRealizado.percentual;

    this.updateChartById('chartRealizado');
    this.spinnerService.hide();
    if (!this.agendamentoRealizado || this.agendamentoRealizado.quantidade === 0) {
      return false;
    }

    return false;
  }

  public async GetGraphAcolhimentoConcluido() {
    this.spinnerService.show();
    const parametros = this.SetParametrosGrafico();

    const result = await lastValueFrom(this.graficoService.GetDataGraphAcolhimentoConcluido(parametros))
      .catch((err) => this.convivaErrors.handleResultError(err));

    if (!result?.isSucess) {
      this.toastr.error(result?.message || 'Erro ao carregar gráfico Acolhimento concluído');
      this.spinnerService.hide();
      return;
    }

    this.acolhimentoConcluido = result.data;




    this.qtyEncaminhamentosConcluidos = new Intl.NumberFormat('pt-BR').format(this.acolhimentoConcluido.quantidade);
    this.porcEncaminhamentosConcluido = this.acolhimentoConcluido.percentual;

    //// Atualiza somente a posição 0
    this.barChartDataAcolhimento.datasets[0].data[0] = this.acolhimentoConcluido.percentual;

    this.updateChartById('chartConcluido');
    this.spinnerService.hide();
    if (!this.acolhimentoConcluido || this.acolhimentoConcluido.quantidade === 0) {
      return false;
    }

    return true;
  }

  public async GetGraphAcolhimentoAtraso() {
    this.spinnerService.show();
    const parametros = this.SetParametrosGrafico();

    const result = await lastValueFrom(this.graficoService.GetDataGraphAcolhimentoAtraso(parametros))
      .catch((err) => this.convivaErrors.handleResultError(err));

    if (!result?.isSucess) {
      this.toastr.error(result?.message || 'Erro ao carregar gráfico Acolhimento em atraso');
      this.spinnerService.hide();
      return;
    }

    this.acolhimentoAtraso = result.data;

    this.qtyEncaminhamentosAtraso = new Intl.NumberFormat('pt-BR').format(this.acolhimentoAtraso.quantidade);
    this.porcEncaminhamentosAtraso = this.acolhimentoAtraso.percentual;

    //// Atualiza somente a posição 0
    this.barChartDataAtraso.datasets[0].data[0] = this.acolhimentoAtraso.percentual;

    this.updateChartById('chartAtraso');
    this.spinnerService.hide();

    if (!this.acolhimentoConcluido || this.acolhimentoConcluido.quantidade === 0) {
      return false;
    }
    return true;
  }

  public async GetGraphPrevencao() {
    this.spinnerService.show();
    const parametros = this.SetParametrosGrafico();

    const result = await lastValueFrom(this.graficoService.GetDataGraphPrevencao(parametros))
      .catch((err) => this.convivaErrors.handleResultError(err));

    if (!result?.isSucess) {
      this.toastr.error(result?.message || 'Erro ao carregar gráfico Prevenção');
      this.spinnerService.hide();
      return;
    }

    this.prevencao = result.data;

    this.qtyEncaminhamentosPrevencao = new Intl.NumberFormat('pt-BR').format(this.prevencao.quantidade);
    this.porcEncaminhamentosPrevencao = this.prevencao.percentual;

    //// Atualiza somente a posição 0
    this.barChartDataPrevencao.datasets[0].data[0] = this.prevencao.percentual;

    this.updateChartById('chartPrevencao');
    this.spinnerService.hide();

    if (!this.prevencao || this.prevencao.quantidade === 0) {
      return false;
    }

    return true;
  }

  public chartClicked({ event, active }: { event?: ChartEvent, active?: {}[] }): void {

  }

  public chartHovered({ event, active }: { event?: ChartEvent, active?: {}[] }): void {

  }

  public async GetGraphValidadosNaoValidados() {
    this.spinnerService.show();
    const parametros = this.SetParametrosGrafico();

    const result = await lastValueFrom(this.graficoService.GetDataValidadosNaoValidados(parametros))
      .catch((err) => this.convivaErrors.handleResultError(err));

    if (!result?.isSucess) {
      this.toastr.error(result?.message || 'Erro ao carregar gráfico Validados x Não Validados');
      this.spinnerService.hide();
      return;
    }

    this.validadosNaoValidados = result.data;

    this.validadosNaoValidados = {
      ...this.validadosNaoValidados,
      validadosFormatado: this.formatarNumero(this.validadosNaoValidados.validados),
      naoValidadosFormatado: this.formatarNumero(this.validadosNaoValidados.naoValidados),
      semAtividadesFormatado: this.formatarNumero(this.validadosNaoValidados.semAtividades),
      totalValidadosNaoValidadosFormatado: this.formatarNumero(this.validadosNaoValidados.totalValidadosNaoValidados)
    };

    //this.chart?.update();
    this.spinnerService.hide();
  }

  public getTooltipValidadosNaoValidados(): string {
    if (!this.validadosNaoValidados) {
      return 'Dados não carregados';
    }
    return `Validados: ${this.validadosNaoValidados.validados} | Não Validados: ${this.validadosNaoValidados.naoValidados} | Sem Atividades: ${this.validadosNaoValidados.semAtividades} | Total: ${this.validadosNaoValidados.totalValidadosNaoValidados}`;
  }

  async ExportarComoPDF() {
    this.spinnerService.show();

    if (!window.jspdf) {
      console.error("Biblioteca jsPDF não encontrada");
      this.spinnerService.hide();
      return;
    }

    const { jsPDF } = window.jspdf;
    const element = this.pdfContent.nativeElement;

    const pdfButton = element.querySelector('.btn-download-pdf');
    if (pdfButton) pdfButton.style.display = 'none';

    const zoom = (window.outerWidth / window.innerWidth) || 1;
    const baseScale = 2;
    const effectiveScale = baseScale / zoom;

    const canvas = await window.html2canvas(element, {
      scale: effectiveScale,
      useCORS: true,
      logging: false,
      windowWidth: element.scrollWidth,
      windowHeight: element.scrollHeight
    });

    if (pdfButton) pdfButton.style.display = '';

    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const marginX = 10;
    const marginTop = 45;

    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pageWidth - marginX * 2;
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    if (this.logoBase64) {
      pdf.addImage(this.logoBase64, 'PNG', pageWidth - 125, 12, 115, 35);
    }

    pdf.setFontSize(20)
      .setFont('helvetica', 'bold')
      .setTextColor(0, 51, 102);
    pdf.text('Relatório PEC', pageWidth / 2, 30, { align: 'center' });

    pdf.setDrawColor(200);
    pdf.line(10, 38, pageWidth - 10, 38);

    pdf.addImage(imgData, 'PNG', marginX, marginTop, pdfWidth, pdfHeight);

    const pageCount = pdf.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      pdf.setPage(i);
      pdf.setFontSize(9).setTextColor(60);
      pdf.text(`Página ${i}`, pageWidth - 15, pageHeight - 8, { align: 'right' });
      pdf.text(`Usuário logado: ${this.userLogado?.nome}`, 10, pageHeight - 8, { align: 'left' });
    }

    pdf.save('relatorio-pec.pdf');
    this.spinnerService.hide();
  }



  getNomeDiretoria(codigo?: number): string {
    const item = this.filtroPadraoComponent?.diretorias?.find(d => d.codigoDiretoria === codigo);
    return item?.nomeDiretoria ?? '-';
  }

  getNomeEscola(codigo?: number): string {
    const item = this.filtroPadraoComponent?.escolas?.find(e => e.codigoEscola === codigo);
    return item?.nomeEscola ?? '-';
  }

  getNomePolo(codigo?: number): string {
    const item = this.filtroPadraoComponent?.polos?.find(p => p.codigoPolo === codigo);
    return item?.descricaoPolo ?? '-';
  }

  getNomeCiclo(codigo?: number): string {
    const item = this.filtroPadraoComponent?.tipoEnsinos?.find(c => c.codigoTipoEnsino === codigo);
    return item?.nomeTipoEnsino ?? '-';
  }
  getNomePsicologo(cpf?: string): string {
    const item = this.filtroPadraoComponent?.lstPsicologos?.find(c => c.codigoCPF === cpf);
    return item?.nomePsicologoCompleto ?? '-';
  }

  private formatarNumero(valor: number): string {
    return new Intl.NumberFormat('pt-BR').format(valor ?? 0);
  }
}
